import React from 'react';
import Notifications from '@material-ui/icons/Notifications';
import {
	OrganizationCoachNotificationCreate,
	OrganizationCoachNotificationEdit,
	OrganizationCoachNotificationsData,
	OrganizationCoachNotificationShow
} from './organization-coach-notification';
import {
	OrganizationNotificationCreate,
	OrganizationNotificationEdit,
	OrganizationNotificationsData,
	OrganizationNotificationShow
} from './organization-notification';

import Lock from '@material-ui/icons/Lock';
import LineWeight from '@material-ui/icons/LineWeight';
import { VerificationsData, VerificationShow } from './verification';

import MenuBook from '@material-ui/icons/MenuBook';
import { TrainingMenuCreate, TrainingMenuEdit, TrainingMenusData, TrainingMenuShow } from './training-menu';

import Settings from '@material-ui/icons/Settings';
import { OrganizationEdit } from './organization/OrganizationEdit';

import DynamicFeed from '@material-ui/icons/DynamicFeed';
import { TraineeCreate, TraineeEdit, TraineesData, TraineeShow } from './trainee';
import { CoachCreate, CoachEdit, CoachesData, CoachShow } from './coach';

import Category from '@material-ui/icons/Category';
import { RecipeCategoriesData, RecipeCategoryCreate, RecipeCategoryEdit, RecipeCategoryShow } from './recipe-category';

import Restaurant from '@material-ui/icons/Restaurant';
import { RecipeCreate, RecipeEdit, RecipesData, RecipeShow } from './recipe';

import ShoppingCart from '@material-ui/icons/ShoppingCart';
import { ProductCreate, ProductEdit, ProductsData, ProductShow } from './product';
import {
	ProductCategoriesData,
	ProductCategoryCreate,
	ProductCategoryEdit,
	ProductCategoryShow
} from './product-category';

import DirectionsRun from '@material-ui/icons/DirectionsRun';
import { MarathonCreate, MarathonEdit, MarathonsData, MarathonShow } from './marathon';
import { DynamicCardCreate, DynamicCardEdit, DynamicCardsData, DynamicCardShow } from './dynamic-card';
import { BillboardCreate, BillboardEdit, BillboardsData, BillboardShow } from './billboard';

import FitnessCenter from '@material-ui/icons/FitnessCenter';
import { TrainingCreate, TrainingEdit, TrainingsData, TrainingShow } from './training';
import {
	TrainingCategoriesData,
	TrainingCategoryCreate,
	TrainingCategoryEdit,
	TrainingCategoryShow
} from './training-category';

import Book from '@material-ui/icons/Book';
import { SuccessStoriesData, SuccessStoryCreate, SuccessStoryEdit, SuccessStoryShow } from './success-story';

import {
	SuccessStoryCategoriesData,
	SuccessStoryCategoryCreate,
	SuccessStoryCategoryEdit,
	SuccessStoryCategoryShow
} from './success-story-category';
import { i18nProvider } from './providers/i18n.provider';
import DataProvider from './providers/data.provider';
import { jwtAuthProvider } from './providers/auth.provider';
import { Admin, Resource } from 'react-admin';
import { theme } from './theme';
import { CustomLoginPage } from './auth/Login';
import { CustomLayout } from './components/CustomLayout';
import { Dashboard } from './components/dashboard/Dashboard';
import './App.scss';
import { NotificationsForm } from './notifications/NotificationsForm';
import { CoachGuideCreate, CoachGuideEdit, CoachGuidesData, CoachGuideShow } from './coach-guide';
import {
	CoachGuideCategoriesData,
	CoachGuideCategoryCreate,
	CoachGuideCategoryEdit,
	CoachGuideCategoryShow
} from './coach-guide-category';
import { LiveTrainingEdit } from "./live-training/LiveTrainingEdit";
import { LiveTrainingCreate } from "./live-training/LiveTrainingCreate";
import { LiveTrainingShow } from "./live-training/LiveTrainingShow";
import { LiveTrainingsData } from "./live-training";
import { LiveTrainingsMessageData } from "./live-training-message";
import { LiveTrainingMessageEdit } from "./live-training-message/LiveTrainingMessageEdit";
import { LiveTrainingMessageCreate } from "./live-training-message/LiveTrainingMessageCreate";
import { LiveTrainingMessageShow } from "./live-training-message/LiveTrainingMessageShow";
import { TagsData } from "./tag";
import { TagEdit } from "./tag/TagEdit";
import { TagCreate } from "./tag/TagCreate";
import { TagShow } from "./tag/TagShow";

const App = (): React.ReactElement => {
	return (
		<div className="App" dir="ltr">
			<Admin
				loginPage={CustomLoginPage}
				theme={theme}
				layout={CustomLayout}
				dashboard={Dashboard}
				title={'FitTech | Admin Panel'}
				dataProvider={DataProvider}
				authProvider={jwtAuthProvider}
				i18nProvider={i18nProvider}>
				{permissions => [
					permissions?.organizationId === 1 ?
						<Resource
							icon={Lock}
							name="verifications"
							options={{ label: 'VERIFICATIONS' }}
							list={VerificationsData}
							show={VerificationShow}
						/> : <></>,

					<Resource
						icon={Notifications}
						name="organization-coach-notifications"
						options={{ label: 'COACH_FOLLOWUPS' }}
						list={OrganizationCoachNotificationsData}
						edit={OrganizationCoachNotificationEdit}
						create={OrganizationCoachNotificationCreate}
						show={OrganizationCoachNotificationShow}
					/>,

					<Resource
						icon={Notifications}
						name="organization-notifications"
						options={{ label: 'ORGANIZATION_NOTIFICATIONS' }}
						list={OrganizationNotificationsData}
						edit={OrganizationNotificationEdit}
						create={OrganizationNotificationCreate}
						show={OrganizationNotificationShow}
					/>,

					<Resource
						icon={LineWeight}
						name="weightings"
						options={{ label: 'WEIGHTINGS' }}
					/>,

					<Resource
						icon={Notifications}
						name="notifications"
						options={{ label: 'NOTIFICATIONS' }}
						create={NotificationsForm}
					/>,

					<Resource
						icon={MenuBook}
						name="training-menus"
						options={{ label: 'TRAINING_MENUS' }}
						list={TrainingMenusData}
						edit={TrainingMenuEdit}
						create={TrainingMenuCreate}
						show={TrainingMenuShow}
					/>,

					<Resource
						icon={Settings}
						name="organizations"
						options={{ label: 'ORGANIZATIONS' }}
						edit={OrganizationEdit}
					/>,

					<Resource
						icon={DynamicFeed}
						name="trainees"
						options={{ label: 'TRAINEES' }}
						list={TraineesData}
						edit={TraineeEdit}
						create={TraineeCreate}
						show={TraineeShow}
					/>,

					<Resource
						icon={DynamicFeed}
						name="coaches"
						options={{ label: 'COACHES' }}
						list={CoachesData}
						edit={CoachEdit}
						create={CoachCreate}
						show={CoachShow}
					/>,

					<Resource
						icon={Category}
						name="recipe-categories"
						options={{ label: 'RECIPE_CATEGORIES' }}
						list={RecipeCategoriesData}
						edit={RecipeCategoryEdit}
						create={RecipeCategoryCreate}
						show={RecipeCategoryShow}
					/>,

					<Resource
						icon={Restaurant}
						name="recipes"
						options={{ label: 'RECIPES' }}
						list={RecipesData}
						edit={RecipeEdit}
						create={RecipeCreate}
						show={RecipeShow}
					/>,

					<Resource
						icon={Restaurant}
						name="tags"
						options={{ label: 'TAGS' }}
						list={TagsData}
						edit={TagEdit}
						create={TagCreate}
						show={TagShow}
					/>,

					<Resource
						icon={Category}
						name="coach-guide-categories"
						options={{ label: 'COACH_GUIDE_CATEGORIES' }}
						list={CoachGuideCategoriesData}
						edit={CoachGuideCategoryEdit}
						create={CoachGuideCategoryCreate}
						show={CoachGuideCategoryShow}
					/>,

					<Resource
						icon={Restaurant}
						name="coach-guides"
						options={{ label: 'COACH_GUIDES' }}
						list={CoachGuidesData}
						edit={CoachGuideEdit}
						create={CoachGuideCreate}
						show={CoachGuideShow}
					/>,

					<Resource
						icon={ShoppingCart}
						name="products"
						options={{ label: 'PRODUCTS' }}
						list={ProductsData}
						edit={ProductEdit}
						create={ProductCreate}
						show={ProductShow}
					/>,

					<Resource
						icon={Category}
						name="product-categories"
						options={{ label: 'PRODUCT_CATEGORIES' }}
						list={ProductCategoriesData}
						edit={ProductCategoryEdit}
						create={ProductCategoryCreate}
						show={ProductCategoryShow}
					/>,

					<Resource
						icon={DirectionsRun}
						name="marathons"
						options={{ label: 'MARATHONS' }}
						list={MarathonsData}
						edit={MarathonEdit}
						create={MarathonCreate}
						show={MarathonShow}
					/>,

					<Resource
						icon={DynamicFeed}
						name="dynamic-cards"
						options={{ label: 'DYNAMIC_CARDS' }}
						list={DynamicCardsData}
						edit={DynamicCardEdit}
						create={DynamicCardCreate}
						show={DynamicCardShow}
					/>,

					<Resource
						icon={DynamicFeed}
						name="billboards"
						options={{ label: 'BILLBOARDS' }}
						list={BillboardsData}
						edit={BillboardEdit}
						create={BillboardCreate}
						show={BillboardShow}
					/>,
					<Resource
						icon={FitnessCenter}
						name="live-trainings-message"
						options={{ label: 'LIVE_TRAININGS_MESSAGE' }}
						list={LiveTrainingsMessageData}
						edit={LiveTrainingMessageEdit}
						create={LiveTrainingMessageCreate}
						show={LiveTrainingMessageShow}
					/>,
					<Resource
						icon={FitnessCenter}
						name="live-trainings"
						options={{ label: 'LIVE_TRAININGS' }}
						list={LiveTrainingsData}
						edit={LiveTrainingEdit}
						create={LiveTrainingCreate}
						show={LiveTrainingShow}
					/>,
					<Resource
						icon={FitnessCenter}
						name="trainings"
						options={{ label: 'TRAININGS' }}
						list={TrainingsData}
						edit={TrainingEdit}
						create={TrainingCreate}
						show={TrainingShow}
					/>,

					<Resource
						icon={Category}
						name="training-categories"
						options={{ label: 'TRAINING_CATEGORIES' }}
						list={TrainingCategoriesData}
						edit={TrainingCategoryEdit}
						create={TrainingCategoryCreate}
						show={TrainingCategoryShow}
					/>,

					<Resource
						icon={Category}
						name="success-story-categories"
						options={{ label: 'SUCCESS_STORY_CATEGORIES' }}
						list={SuccessStoryCategoriesData}
						edit={SuccessStoryCategoryEdit}
						create={SuccessStoryCategoryCreate}
						show={SuccessStoryCategoryShow}
					/>,

					<Resource
						icon={Book}
						name="success-stories"
						options={{ label: 'SUCCESS_STORIES' }}
						list={SuccessStoriesData}
						edit={SuccessStoryEdit}
						create={SuccessStoryCreate}
						show={SuccessStoryShow}
					/>,
					<Resource
						icon={Category}
						name="success-story-categories"
						options={{ label: 'SUCCESS_STORY_CATEGORIES' }}
						list={SuccessStoryCategoriesData}
						edit={SuccessStoryCategoryEdit}
						create={SuccessStoryCategoryCreate}
						show={SuccessStoryCategoryShow}
					/>,

					<Resource
						name="organizations"
						options={{ label: 'ORGANIZATIONS' }}
					/>,
					<Resource
						name="clients"
						options={{ label: 'CLIENTS' }}
					/>
				]}
			</Admin>
		</div>
	);
};

export default App;
